import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import type { Contact } from './types/contactTypes'
import type { PaginatedResponse } from './types/paginatedTypes'

const fetchClassifyContacts = async (): Promise<Contact[]> => {
  // Include ghost profiles (imported / hand-created contacts): they are exactly
  // the ones that still need to be sorted into Privé / Pro here.
  const { data } = await api.get<PaginatedResponse<Contact>>('/contacts?limit=200')
  return data.data
}

export const useFtClassifyContacts = () => {
  return useQuery<Contact[]>({
    queryKey: ['ft-classify-contacts'],
    queryFn: fetchClassifyContacts,
  })
}
